import { ChangeEvent, FC, memo, useCallback, useMemo, useRef } from "react";
import { useTranslation } from "react-i18next";
import { SpeedDial, SpeedDialAction, SpeedDialIcon, useTheme } from "@mui/material";
import IconSave from "@mui/icons-material/Save";
import IconFolderOpen from "@mui/icons-material/FolderOpen";
import getStyles from "./styles";

interface ProjectManagerProps {
  saveProject: () => void;
  openProject: (event: ChangeEvent<HTMLInputElement>) => void;
}

export const ProjectManager: FC<ProjectManagerProps> = ({ saveProject, openProject }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const styles = useMemo(() => getStyles(theme), [theme]);
  const inputRef = useRef<HTMLInputElement>(null);

  const handleUpload = useCallback(() => {
    if (inputRef.current) {
      inputRef.current.click();
    }
  }, []);

  return (
    <>
      <SpeedDial ariaLabel="save/open street" sx={styles.container} icon={<SpeedDialIcon />} className="RlxProjectManager">
        <SpeedDialAction icon={<IconSave />} tooltipTitle={t("Save Project")} onClick={saveProject} />
        <SpeedDialAction icon={<IconFolderOpen />} tooltipTitle={t("Open Project")} onClick={handleUpload} />
      </SpeedDial>
      <input hidden type="file" ref={inputRef} onChange={openProject} style={{ display: "none" }} />
    </>
  );
};

ProjectManager.displayName = "ProjectManager";

export default memo(ProjectManager);
